var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 14.497c-.397 0-.777-.156-1.06-.439l-3-3a1.497 1.497 0 010-2.12 1.497 1.497 0 012.12 0l1.815 1.815 4.953-6.19a1.5 1.5 0 012.343 1.873l-5.999 7.498a1.49 1.49 0 01-1.089.559l-.082.004z"
  })));
}
export default SvgVIcon;